// Floating camera-preset bar — bottom-left viewport overlay (desktop only).
// Wraps CameraPresetGrid with title + glass background.

import {useMemo} from 'react'
import {Box, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import CameraPresetGrid from './CameraPresetGrid'
import {useAppTokens} from '../../theme'
import type {ThemeTokens} from '../../theme'

const CameraPresetBar = () => {
  const {t} = useTranslation()
  const tokens = useAppTokens()
  const sx = useMemo(() => buildStyles(tokens), [tokens])

  return (
    <Box sx={sx.root}>
      <Typography sx={sx.title}>{t('scene.camera.presets')}</Typography>
      <CameraPresetGrid />
    </Box>
  )
}

const buildStyles = (tokens: ThemeTokens) => ({
  root: {
    position: 'absolute' as const,
    bottom: 12,
    left: 12,
    zIndex: 20,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '6px',
    padding: '8px 10px 8px',
    borderRadius: '10px',
    backgroundColor: tokens.surface.glass,
    backdropFilter: 'blur(12px)',
    border: `1px solid ${tokens.accordion.border}`,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.3)',
  },
  title: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.06em',
    color: 'rgba(255, 255, 255, 0.65)',
    userSelect: 'none' as const,
    paddingLeft: '2px',
  },
})

export default CameraPresetBar
